
import { Component, Vue } from "vue-property-decorator";
import NavBar from "@/components/navBar.vue";
import { districtList } from "@/req/homeIndex";
@Component({
  components: {
    NavBar,
  },
})
export default class Logout extends Vue {
  public serverList = [];
  public serverId: any = this.$route.query.serverId;
  public obj: any = this.$route.query.obj;
  public created() {
    this.serverChange();
  }
  public async serverChange() {
    const res = await districtList({
      box_game_id: this.serverId,
    });
    if (res.code === 200) {
      this.serverList = res.data;
    }
  }
}
